import { NgModule } from 'ng-metadata/core';
import {PrmReportProblem} from "./reportProblem.directive";
import {ReportProblemService} from "./reportProblem.service";

@NgModule({
    declarations: [
        PrmReportProblem
    ],
    providers: [
        ReportProblemService
    ],
    imports: [

    ]
})
export class ReportProblemModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/reportProblem/reportProblem.module.ts